// src/services/fakeAuthService.js
import { dummyUsers } from '../../../mock/dummyUsers'; 
import { accessMatrix } from '../../../mock/accessMatrix';


let verificationCodeStore = {}; // format: { email: '123456' }

export const login = async ({ email, password }) => {
  const user = dummyUsers.find(
    (u) => u.email === email && u.password === password
  );

  if (user) {
    return {
  id: user.id,
  email: user.email,
  name: user.name,
  role: user.role,
  access: accessMatrix[user.role] || {},
  token: 'dummy-token',
};

  } else {
    throw new Error('Email atau password salah');
  }
};

export const sendVerificationCode = async (email) => {
  const userExists = dummyUsers.some((u) => u.email === email);
  if (!userExists) {
    throw new Error('Email tidak ditemukan');
  }

  const code = Math.floor(100000 + Math.random() * 900000).toString(); // 6 digit kode
  verificationCodeStore[email] = code;

  console.log(`[dummy] Kode verifikasi dikirim ke ${email}: ${code}`);
  return { message: 'Kode verifikasi dikirim' };
};

export const verifyCode = async (email, code) => {
  const validCode = verificationCodeStore[email];
  if (validCode === code) {
    return { message: 'Kode benar' };
  } else {
    throw new Error('Kode salah');
  }
};

export const resetPassword = async (email, newPassword) => {
  const user = dummyUsers.find((u) => u.email === email);
  if (!user) {
    throw new Error('User tidak ditemukan');
  }

  user.password = newPassword;
  delete verificationCodeStore[email];

  return { message: 'Password berhasil diubah' };
};
